module.exports = __webpack_public_path__ + "assets/img/thumb-The-Strand-Coollangatta-Video.75c66c03.webp";